var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEr = function SvgIconEr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M10.957 10.957s-7.435 9.53-7.442 9.528A11.96 11.96 0 0 0 12 24c6.627 0 12-5.373 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M10.957 12S3.522 3.513 3.515 3.514A11.96 11.96 0 0 1 12 0c6.627 0 12 5.372 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.514 3.515c-4.687 4.687-4.687 12.285 0 16.971 0 .002 20.485-8.485 20.485-8.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M6.26 7.043a4.18 4.18 0 0 0-4.173 4.174v1.565a4.18 4.18 0 0 0 4.174 4.174 4.18 4.18 0 0 0 4.174-4.174v-1.565A4.18 4.18 0 0 0 6.26 7.043m2.61 5.74a2.61 2.61 0 0 1-1.827 2.488v-1.706l1.108-1.107-1.107-1.107v-.916H5.477V12l-1.106 1.106 1.106 1.107v1.058a2.61 2.61 0 0 1-1.826-2.489v-1.565A2.61 2.61 0 0 1 6.261 8.61a2.61 2.61 0 0 1 2.608 2.608z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconEr;